import { useNavigate } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { PROJECTS } from "../../data/site";

export const Projects = () => {
  const navigate = useNavigate();

  return (
  <section id="projects" data-testid="projects-section" className="bg-white py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-6">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <Reveal>
            <Kicker index="03" label="Portfolio" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-5xl font-bold uppercase tracking-tight text-ink md:text-6xl">
              Recent Projects
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-sm leading-relaxed text-fog">
            Real recent builds across Hounslow, Hayes, Ilford, Langley and
            Sunbury — extensions, garden rooms, kitchens and full renovations.
            Click any project for the full case study.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-6 md:grid-cols-2">
        {PROJECTS.map((project, i) => (
          <Reveal
            key={project.slug}
            delay={(i % 2) * 0.1}
            className={i === 0 || i === 5 ? "md:col-span-2" : ""}
          >
            <article
              data-testid={`project-card-${i + 1}`}
              onClick={() => navigate(`/projects/${project.slug}`)}
              className={`group relative cursor-pointer overflow-hidden border border-black/10 bg-ink ${
                i === 0 || i === 5 ? "h-[380px] md:h-[480px]" : "h-[380px] md:h-[420px]"
              }`}
            >
              <img
                src={project.img}
                alt={project.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/95 via-white/35 to-transparent transition-opacity duration-500" />

              <div className="absolute left-5 top-5 flex items-center gap-2 bg-white/85 px-3 py-2 backdrop-blur-md">
                <MapPin className="h-3.5 w-3.5 text-bronze" />
                <span className="text-[11px] uppercase tracking-[0.2em] text-ink/85">
                  {project.location}
                </span>
              </div>

              <div className="absolute right-5 top-5 grid h-11 w-11 translate-y-2 place-items-center border border-black/15 bg-white/85 opacity-0 backdrop-blur-md transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <ArrowUpRight className="h-5 w-5 text-bronze" />
              </div>

              <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                <span className="text-xs font-semibold tracking-[0.3em] text-bronze">
                  {String(i + 1).padStart(2, "0")} — {project.service}
                </span>
                <h3 className="mt-2 font-display text-3xl font-bold uppercase tracking-wide text-ink md:text-4xl">
                  {project.title}
                </h3>
                <p className="mt-3 max-w-md translate-y-3 text-sm leading-relaxed text-black/70 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                  {project.desc}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
